export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/aadf7e204ac3ecb8628e2b693a3c4a40.svg";